function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var ExternalLink = function ExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M10.999 2.81a1 1 0 1 1 0 2h-8v15.998h15.998v-8a1 1 0 1 1 2 0v8.202a1.8 1.8 0 0 1-1.797 1.798H2.798A1.8 1.8 0 0 1 1 21.01V4.608A1.8 1.8 0 0 1 2.798 2.81zM21.983 1l.039.001.043.003zq.08 0 .158.013l.022.004.019.003.03.007.038.01.049.015a1 1 0 0 1 .107.042q.034.016.069.035l.029.018.015.009c.13.083.24.195.32.327l.005.009.011.019a1 1 0 0 1 .079.18l.013.044q.01.036.018.076l.005.032.01.078.002.044v-.001 7.211a1 1 0 1 1-2 0V4.402l-8.18 8.126a1 1 0 0 1-1.41-1.42L19.556 3h-4.748a1 1 0 1 1 0-2z"
  }));
};
export default ExternalLink;